{
  "tabs": {
    "chat": "ޗެޓް",
    "reminders": "ރިމައިންޑަރު",
    "calendar": "ކެލެންޑަރ",
    "settings": "ސެޓިންގސް"
  },
  "common": {
    "cancel": "ބައްދަލު",
    "save": "ސޭވް",
    "confirm": "އިންސްޓާ",
    "delete": "ފުރަތަމަ",
    "back": "ބައި",
    "close": "ކްލޯސް",
    "edit": "އެޑިޓް",
    "search": "ސާރޗް",
    "all": "ހުރި",
    "loading": "ލޯޑިންގ...",
    "error": "އެރަރ އަދިއްޔާ",
    "notFound": "ނޫންވަނީ",
    "tryAgain": "އަދިވަނީ ސްޓްރައިކް",
    "retry": "ކުރަން",
    "undo": "އުންޑޫ",
    "pullToRefresh": "ރިފްރެޝް ކޮށްފިނަމަ",
    "justNow": "އިންސާމުގެ"
  },
  "auth": {
    "welcome": "ފިޝްމެމަރީއަށް ވަނީ",
    "tagline": "އައިޓެމް WhatsApp ރިމައިންޑަރ އަސިސްޓަންޓް، އަހަރެން އައިޕްލިކޭޝަންގެ ޕޮކެޓްގައި.",
    "subtitle": "އައިޓެމް WhatsApp ރިމައިންޑަރ އަސިސްޓަންޓް، އަހަރެން އައިޕްލިކޭޝަންގެ ޕޮކެޓްގައި.",
    "phoneLabel": "އައިޓެމް WhatsApp ނަންބަރު",
    "phoneHint": "އައިޓެމް WhatsApp ގައި ވެރިފިކޭޝަން ކޯޑް ސެންޑް ކުރަންވީ",
    "invalidPhone": "ސަބަބު ނަންބަރު ލިޔުން",
    "continue": "މަގާމަށް",
    "enterPhone": "އައިޓެމް WhatsApp ނަންބަރު ލިޔުން",
    "phonePlaceholder": "ނަންބަރު",
    "sendCode": "ކޯޑް ސެންޑް ކުރަން",
    "verifyTitle": "ނަންބަރު ވެރިފައި",
    "otpSentTo": "އެސްސިކްސް ޑިޖިޓް ކޯޑް {{phone}} ގައި WhatsApp ގައި ސެންޑްކޮށްލާނެ",
    "enterFullCode": "ސަބް 6 ޑިޖިޓް ލިޔުން",
    "invalidOtp": "ކޯޑް ނުކުރެވޭ. އަދިވަނީ ސްޓްރައިކް.",
    "otpFailed": "ކޯޑް ސެންޑް ނުކުރެވޭ. އަދިވަނީ ސްޓްރައިކް.",
    "otpResent": "ކޯޑް ސެންޑް ކޮށްލާނެ",
    "resendIn": "{{seconds}} ސިކަންޑުގެ ބައި ސެންޑް ކުރަން",
    "resendCode": "ކޯޑް ސެންޑް ކުރަން",
    "enterOtp": "ކޯޑް ލިޔުން އައިޓެމް WhatsApp ގައި ސެންޑް ކޮށްލާނެ",
    "verify": "ވެރިފައި",
    "resend": "ކޯޑް ސެންޑް ކުރަން",
    "wrongNumber": "ނަންބަރު ނުކުރެވޭ؟",
    "backToPhone": "ބައި ނަންބަރު",
    "editPhone": "ނަންބަރު އެޑިޓް ކުރަން",
    "error": "އެރަރ",
    "setupTitle": "އަހަރެން ސެޓަޕް ކުރަން",
    "setupSubtitle": "ސެޓިންގސް ގައި ބައްދަލު ކުރަން ކުރަން ކަމަކުން އެއްޗެއް ނުވަތަ ކޮށްލާނެ.",
    "namePlaceholder": "އައިޓެމް ނަން",
    "letsGo": "ސެޓަޕް ކުރަން",
    "skipForNow": "މިހާރު އަދި އަންނަވާ"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "މެސެޖް ލިޔުން...",
    "inputPlaceholder": "މެސެޖް ލިޔުން...",
    "typing": "FishMemory ލިޔުންގެން...",
    "online": "އޮންލައިން",
    "connecting": "ކޮނެކްޓިންގ...",
    "reconnecting": "ކޮނެކްޓް ކުރަންގެން...",
    "offline": "އޮފްލައިން",
    "empty": "ހުރި ސައިންގް ކުރަން",
    "emptyHint": "ރިމައިންޑަރު ހަދަން، ސްކެޖުލް ޗެކް ކުރަން ނުވަތަ އޮލްލައިން ރަނގަޅު ކުރަން.",
    "emptyAction": "ސަމްޕަލް ރިމައިންޑަރ ސެންޑް ކުރަން",
    "actions": "ޗެޓް އެކްޝަންސް",
    "keep": "މެސެޖްސް ކުރުން",
    "clearTitle": "ޗެޓް ކްލީރް ކުރަން",
    "clearConfirm": "މި ޑީވައިސް މަދު މެސެޖްސް ފުރަތަމަކުރަން؟ މިއީ ބަޔާންކޮށްލާނެ.",
    "clear": "ޗެޓް ކްލީރް ކުރަން",
    "optionSelected": "ސެލެކްޓެޑް: {{label}}",
    "sendingSelection": "ސެންޑިންގ...",
    "connectionLost": "ކޮނެކްޝަން ދިޔަ އަދި ކޮނެކްޓް ކުރަންގެން..."
  },
  "reminders": {
    "title": "މައި ރިމައިންޑަރު",
    "active": "ހަދާފަ",
    "today": "މިއަދު",
    "thisWeek": "މި ހައްޔާ",
    "history": "ހިސްޓްރީ",
    "items": "އައްސަލަތް",
    "emptyTitle": "މިހާރު ރިމައިންޑަރު ނުފެނުނު",
    "emptySubtitle": "ޗެޓް ގައި ހަދަން އަދި މިހާރު ވަނީ މިތާވަކަށް ދިމާލު.",
    "emptyAction": "ޗެޓް ބައި",
    "filterActive": "ހަދާފަ",
    "filterToday": "މިއަދު",
    "filterWeek": "މި ހައްޔާ",
    "filterHistory": "ހިސްޓްރީ",
    "emptyState": "މިހާރު ރިމައިންޑަރު ނުފެނުނު. ޗެޓް ކުރަން!",
    "swipeDone": "ކުރިއަށް",
    "swipeSnooze": "ސްނޫޒް",
    "swipeDelete": "ފުރަތަމަ",
    "search": "ރިމައިންޑަރު ސާރޗް...",
    "upcoming": "ކުރިއަށް ބަޔާން",
    "completed": "ކުރިއަށް",
    "overdue": "ފަހުންނަށް",
    "tomorrow": "މާދަމާ",
    "synced": "ސިންކް ކުރެވިފައި {{value}}",
    "swipeHint": "ރިމައިންޑަރު ސްވައިޕް ކުރަން އެކްޝަންސް ބަޔާން",
    "noResults": "ރިމައިންޑަރު ސާރޗް ގައި ނުފެނުނު",
    "noResultsHint": "އެއްޗެއް ކުރަން ނުކުރެވޭ ކީވޯޑް ނުވަތަ ސާރޗް ކްލިއާރް ކުރަން",
    "deleteAllFailed": "ސަބް ރިމައިންޑަރު ފުރަތަމަ ނުކުރެވޭ"
  },
  "calendar": {
    "title": "ކެލެންޑަރ",
    "today": "މިއަދު",
    "tomorrow": "މާދަމާ",
    "completed": "ކުރިއަށް",
    "noEvents": "ހުރި އިވެރިންގް ނުފެނުނު",
    "noEventsSubtitle": "ރިމައިންޑަރު އަދި ކެލެންޑަރ އިވެރިންގް ހަދަން ދިމާލު.",
    "googleEvent": "Google Calendar",
    "legendActive": "ހަދާފަ",
    "legendRecurring": "އަދިއަދި",
    "legendDone": "ކުރިއަށް",
    "legendGoogle": "Google",
    "previousMonth": "ފަހުގެ މަސް",
    "nextMonth": "މަތިވަނީ މަސް",
    "previousYear": "ފަހުގެ އަހަރަށް",
    "nextYear": "މަތިވަނީ އަހަރަށް",
    "goToToday": "މިއަދު ބައި",
    "all": "ހުރި",
    "active": "ހަދާފަ",
    "done": "ކުރިއަށް",
    "paused": "ޕޯސް"
  },
  "settings": {
    "title": "ސެޓިންގސް",
    "profile": "ޕްރޮފައިލް",
    "name": "ޑިސްޕްލޭ ނަން",
    "enterName": "ނަން ލިޔުން",
    "language": "ބަސް",
    "uiLanguage": "އެޕްލިކޭޝަން ބަސް",
    "uiLanguageHelp": "މި ޑީވައިސްގައި އެޕްލިކޭޝަން ޔޫއައި، ކެލެންޑަރ ލޭބަލްސް އަދި ލަޔައުޓް ޑައިރެކްޝަން ބަޔާންކުރަން.",
    "serverLanguage": "ޗެޓް ބަސް",
    "serverLanguageHelp": "ސަރވަރު ގައި ބަސް ބަޔާންކުރަން އަދި ރިމައިންޑަރ މެސެޖްސް ބަޔާންކުރަން.",
    "timezone": "ޓައިމްޒޯން",
    "currentTimezone": "މިހާރު ޓައިމްޒޯން",
    "timezoneHelp": "ސަބް ރިމައިންޑަރ ޓައިމް މި ޓައިމްޒޯން ގައި ދިމާލު ކުރަން.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "ޓައިމްޒޯން ސޭވް ކުރަން",
    "timezoneSaved": "ޓައިމްޒޯން އަޕްޑޭޓް ކުރެވިފައި",
    "detect": "ޑިޓެކްޓް",
    "detectFailed": "ޓައިމްޒޯން ނުޑެޓެކްޓް ކުރެވޭ",
    "autoDetect": "އައުޓޯ ޑިޓެކްޓް ގިއްޖެއަށް GPS ގައި",
    "notifications": "ނޮޓިފިކޭޝަންސް",
    "notificationsHelp": "ފޮލޯ-އަޕް ރިމައިންޑަރު އެލާރޓްތައް ބަޔާންކުރަން ކުރެވޭ. ޑީވައިސް ސެޓިންގސްގައި ނޮޓިފިކޭޝަން ސަބްސްކްރިޕްޝަން ބަޔާންކުރަން ކުރެވޭ.",
    "pushEnabled": "ޕުޝް ނޮޓިފިކޭޝަންސް",
    "autoDoneOnFire": "ފައިރް ކޮށްލާނެ އައިޓެމް ކުރިއަށް",
    "autoDoneOnFireDesc": "އޮފް ކޮށްލާނެ ރިމައިންޑަރު ކުރިއަށް އައިން ނުވަތަ ކުރަން.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "ކޮނެކްޓެޑް",
    "googleDisconnected": "ނޮޓް ކޮނެކްޓެޑް",
    "googleConnectedHelp": "އައިޓެމް ރިމައިންޑަރު އަދި ކެލެންޑަރ އެވެރޓްސް ސިންކް ކުރަން ކުރެވޭ.",
    "googleDisconnectedHelp": "Google Calendar ކޮނެކްޓް ކުރަން ރިމައިންޑަރު އަދި އެވެރޓްސް އަލިން ކުރަން.",
    "googleConnectFailed": "Google Calendar ކޮނެކްޓް ނުކުރެވޭ",
    "connected": "ކޮނެކްޓެޑް",
    "disconnected": "ނޮޓް ކޮނެކްޓެޑް",
    "connect": "ކޮނެކްޓް",
    "disconnect": "ޑިސްކޮނެކްޓް",
    "autoSync": "އައުޓޯ ސިންކް ކުރަން",
    "autosync": "އައުޓޯ ސިންކް ކުރަން",
    "subscription": "ސަބްސްކްރިޕްޝަން",
    "trialUsed": "ޓްރައިއަލް: {{used}}/{{total}} ބަޔާން",
    "trialStatus": "ޓްރައިއަލް މިހާރު",
    "activeStatus": "ހަދާފަ ސަބްސްކްރިޕްޝަން",
    "expiredStatus": "ސަބްސްކްރިޕްޝަން އެކްސްޕައިރްކުރެވޭ",
    "unsubscribedStatus": "ނުސަބްސްކްރިބްކުރެވޭ",
    "about": "އަބައުޓް",
    "version": "ވަރޝަން",
    "logout": "ލޮގް އުޓް",
    "logoutTitle": "ލޮގް އުޓް",
    "logoutConfirm": "ލޮގް އުޓް ކުރަން މިހާރު އެއްޗެއް އެންމެނޭ؟",
    "noName": "ނަން ނުސެޓް ކުރެވޭ",
    "serverConnection": "ސަރވަރު ކޮނެކްޝަން",
    "serverUrl": "ސަރވަރު URL",
    "serverEdit": "އެޑިޓް",
    "saveReconnect": "ސޭވް އަދި ކޮނެކްޓް ކުރަން",
    "resetDefault": "ޑިފޯލްޓް ރީސެޓް",
    "invalidServerUrlTitle": "ސަރވަރު URL ނުކުރެވޭ",
    "invalidServerUrlMessage": "ސަރވަރު URL ލިޔުން ކުރަން http ނަމަ ނުވަތަ https://example.com މަގާމަށް",
    "uiLanguageChangeFailed": "އެޕްލިކޭޝަން ބަސް ބަޔާންކުރަން ނުކުރެވޭ. އަދިވަނީ ސްޓްރައިކް.",
    "serverLanguageChangeFailed": "ޗެޓް ބަސް ބަޔާންކުރަން ނުކުރެވޭ. އަދިވަނީ ސްޓްރައިކް.",
    "timezoneChangeFailed": "ޓައިމްޒޯން ބަޔާންކުރަން ނުކުރެވޭ. އަދިވަނީ ސްޓްރައިކް.",
    "autoSyncChangeFailed": "އައުޓޯ ސިންކް އަޕްޑޭޓް ނުކުރެވޭ. އަދިވަނީ ސްޓްރައިކް.",
    "nameChangeFailed": "ޑިސްޕްލޭ ނަން އަޕްޑޭޓް ނުކުރެވޭ. އަދިވަނީ ސްޓްރައިކް.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "ރިމައިންޑަރ އަދިސްޓްރަކްޝަން",
    "editTime": "ޓައިމް އެޑިޓް ކުރަން",
    "rename": "ނަން ބަޔާންކުރަން",
    "snooze": "ސްނޫޒް",
    "snooze15": "15 މިނިޓް ސްނޫޒް",
    "pause": "ޕޯސް",
    "pauseReminder": "ރިމައިންޑަރ ޕޯސް ކުރަން",
    "resume": "ރިސްމް",
    "resumeReminder": "ރިމައިންޑަރ ރިސްމް ކުރަން",
    "skip": "ނެކްސްޓް ސްކިޕް",
    "skipOccurrence": "މި އޮކަސްރަންސް ސްކިޕް ކުރަން",
    "syncGoogle": "ގޫގްލް ސިންކް ކުރަން",
    "delete": "ފުރަތަމަ",
    "deleteTitle": "ރިމައިންޑަރ ފުރަތަމަ",
    "deleteConfirm": "މި ރިމައިންޑަރ ބަޔާންކުރެވޭ.",
    "deleteRecurringTitle": "އަދިއަދި ރިމައިންޑަރ ފުރަތަމަ",
    "deleteRecurringMessage": "މި އޮކަސްރަންސް ސްކިޕް ކުރަން ނުވަތަ ސިރިސް ފުރަތަމަކުރަން؟",
    "deleteThisOccurrence": "މި އޮކަސްރަންސް ސްކިޕް ކުރަން",
    "deleteEntireSeries": "ސިރިސް ފުރަތަމަ ކުރަން",
    "done": "ކުރިއަށް",
    "markDone": "ކުރިއަށް މާލައްސަތް",
    "undo": "ރިސްޓޯރް",
    "undoPrompt": "މިހާރު ހަދާފަ ކުރަން ކޮށްލާނެ؟ އުންޑޫ ކުރަން.",
    "recurring": "އަދިއަދި",
    "nextRun": "މިތާވަކަށް",
    "oneTime": "އެއް ވަނަ",
    "pending": "މެންޓިންގ",
    "sent": "ސެންޓް",
    "paused": "ޕޯސް",
    "active": "ހަދާފަ",
    "snoozed": "ސްނޫޒް ކުރެވިފައި",
    "localTime": "މިހާރު ލޯކަލް ޓައިމްގައި ދިމާލު",
    "recurrence": "އަދިއަދި ކުރަން",
    "created": "ހުރިހާ",
    "tags": "ޓެގްސް",
    "fireCount": "ފައިރް ކައުންޓް",
    "actions": "އެކްޝަންސް",
    "none": "ނުވަތަ",
    "snoozeFailed": "ރިމައިންޑަރ ސްނޫޒް ނުކުރެވޭ",
    "pauseFailed": "ރިމައިންޑަރ ޕޯސް ނުކުރެވޭ",
    "resumeFailed": "ރިމައިންޑަރ ރިސްމް ނުކުރެވޭ",
    "skipFailed": "ރިމައިންޑަރ ސްކިޕް ނުކުރެވޭ",
    "doneFailed": "ރިމައިންޑަރ ކުރިއަށް މާލައްސަތް ނުކުރެވޭ",
    "undoFailed": "ރިމައިންޑަރ ސްޓޭޓްސް ރިސްޓޯރް ނުކުރެވޭ",
    "deleteFailed": "ރިމައިންޑަރ ފުރަތަމަ ނުކުރެވޭ",
    "rescheduleTitle": "ރިސްކްޑިއުލް؟",
    "rescheduleMsg": "މި ރިމައިންޑަރ ފަހުންނަށް. ރިސްކްޑިއުލް ކުރަން އެންމެނޭ؟",
    "reschedule15": "15 މިނިޓް ގައި",
    "reschedule60": "1 ގައިވާ ގައި",
    "keepOverdue": "މިހާރު ކަމަކުރަން"
  },
  "onboarding": {
    "slide1Title": "ފިޝްމެމަރީއަށް ވަނީ",
    "slide1Sub": "އައިޓެމް ރިމައިންޑަރ އަސިސްޓަންޓް — WhatsApp ގައި ބައްދަލު އަދި ޕޮކެޓްގައި ބައިވެރި.",
    "slide2Title": "އަހަރެން ޗެޓް ކުރަން",
    "slide2Sub": "ރިމައިންޑަރު ލިޔުން ކުރަން: \"މާދަމާ 3 ގައި އައިޓެމް މަމް ކޯލް ކުރަން ރިމައިންޑް ކުރަން\" — އަހަރެން ކުރަން.",
    "slide3Title": "ނުވަތަ ސުވާލު ނުކުރަން",
    "slide3Sub": "ސްޓައިމްލިން ނޮޓިފިކޭޝަންސް، ޓެގްސް ކުރަން އަދި ހުރި މިހާރު ކުރަން.",
    "getStarted": "ބައިވެރި",
    "next": "މަގާމަށް",
    "firstReminderTitle": "ފައިސްޓް ރިމައިންޑަރ ހަދަން!",
    "firstReminderHint": "މިހާރު ލިޔުން ސްޓާޓް ކުރަން:",
    "firstReminderExample": "\"މާދަމާ 9 ގައި ކަމަކު މަގާމަށް ކުރަން\"",
    "gotIt": "ފުރައިން!",
    "notifRationaleTitle": "މިހާރު ކުރަން",
    "notifRationaleBody": "FishMemory މިހާރު ކުރަން ނޮޓިފިކޭޝަންސް ކުރެވޭ. މިހާރު އަދި ރިމައިންޑަރު ކުރަން އެއްޗެއް ނުވަތަ އެލާރޓްތައް ކުރަން.",
    "notifRationaleAllow": "ނޮޓިފިކޭޝަންސް އެނޭބަލް ކުރަން",
    "notifRationaleLater": "މަގާމަށް",
    "swipeHint": "ރައިޓް ސްވައިޕް ކުރަން ކުރިއަށް އެކްޝަންސް →",
    "calendarDragHint": "ޑްރެގް ކުރަން ބަޔާން ↕"
  }
}
